import {BaseSearchableService} from "./Core/BaseSearchableService";

class ContactService extends BaseSearchableService {
    get Url() { return super.Url + "/contacts"; }
    get ModelName() { return "Contact"; }
    get PrimaryKeyProperty() { return "stakeholderId"; }
    // Keep Request free of default params: Search() spreads this.Request AFTER
    // the caller's additionalParams, so any key defaulted here silently beats
    // what callers pass. Callers that want an org-scoped search send
    // organizationId themselves.

    get TitleProperty() { return "displayName"; }

	GetTitle(model, defaultTitle = "(No name)") {
        if(Number(model?.stakeholderTypeId ?? 1) === 1) {
            if(model?.firstName || model?.lastName) {
                return `${model.firstName ?? ''} ${model.lastName ?? defaultTitle}`;
            }
            return defaultTitle;
        }
        return `${model?.organizationName ?? defaultTitle}`;
    }

    HasRequiredContactInfo(contact) {
        const address = contact?.StakeholderAddresses?.Address;
        if (!(address?.email && address?.phone && address?.address1 && address?.city && address?.stateId && address?.zipcode)) {
            return false;
        }
        if (Number(contact?.stakeholderTypeId ?? 1) === 1) {
            return !!(contact?.firstName && contact?.lastName);
        }
        return !!contact?.organizationName;
    }

    FindByName({ firstName, middleName, lastName, organizationName, organizationId }) {
        return this.SendRequest(BaseSearchableService.GET, { firstName, lastName, organizationName, organizationId });
    }
    
    GetProjectContacts(projectId) {
        let request = {projectId: projectId};
        return this.SendRequest(BaseSearchableService.GET, request);
    }

    UpdateContact(contact) {
        return this.SendRequest(BaseSearchableService.PUT, contact);
    }

    CreateContact(contact) {
        return this.SendRequest(BaseSearchableService.POST, contact);
    }

    DeleteContact(contactId) {
        return this.SendRequest(BaseSearchableService.DELETE, contactId);
    }
}

export const service = new ContactService();

